import React, { useRef, useState } from 'react'
import { BankModalContainer, BankWrapper, BankModalBackground } from './style'
import {
  BankTransferText,
  ModalTitleText,
} from 'src/components/Global/Text/TitleText'
import { addNairaSign } from '../../../utils/addNairaSign'
import { CopySvg } from 'src/assets/index'
import { InvestmentBtn } from 'src/components/Global/Button/Button'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components/macro'
import Success from '../PaymentResults/InvestmentSuccess/Success'

const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  /* @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 60px;
  } ; */
`

const BankTransfer = ({
  account,
  amount,
  showModal,
  setShowModal,
  onIHavePaid,
  onIHavePaidModal,
  showOnIHavePaidModal,
}: any) => {
  const [copied, setCopied] = useState('')

  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  const copyCodeToClipBoard = (code: string) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
      // setShowAlert(true)
    }
  }
  // const handleTransfer = (e: any) => {
  //   e.preventDefault()
  //   dispatch(action(PlanTypes.CLEAR_PAYMENT_FORM))
  //   navigate('/homepage')
  // }

  return (
    <BankModalContainer ref={componentRef} onClick={closeModal}>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={closeModal} />
            <div className="title_wrapper">
              <ModalTitleText>Bank Transfer</ModalTitleText>
            </div>

            <div className="amount_description_wrapper">
              <p className="amount_text">{addNairaSign(amount)}</p>
              <p className="description">
                Kindly Transfer the amount to this unique account number using
                your mobile banking or ussd to complete your savings
              </p>
            </div>

            <div className="account_details_wrapper">
              <div className="account_container">
                <p className="bank_name">
                  Bank name\ <small>{account?.bank_name}</small>
                </p>
                <p className="account_num">
                  Account number\ <small>{account?.account_number}</small>
                </p>
                <p className="account_name">
                  Account name\ <small>{account?.bank_name}</small>
                </p>
              </div>

              <div className="copy_container">
                <p
                  className="copy_text"
                  onClick={() => {
                    setCopied(account?.account_number)

                    copyCodeToClipBoard(account?.account_number)
                  }}
                >
                  {copied ? 'copied' : 'copy'}
                  <img src={CopySvg} alt="" />
                </p>
              </div>
            </div>

            <div className="list_wrapper">
              <p>Make transfer to the above account number within 10mins</p>
              <p>Confirmation happens automatically</p>
              <p>
                The account number above is unique and is generated for each
                transaction
              </p>
            </div>

            <div className="done_btn_wrapper">
              <InvestmentBtn onClick={onIHavePaid}>Done</InvestmentBtn>
            </div>
            <Success
              showOnIHavePaidModal={showOnIHavePaidModal}
              onIHavePaidModal={onIHavePaidModal}
            />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export default BankTransfer
